import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (#section), let the browser handle it
    if (hash) return;

    window.scrollTo(0, 0);
  }, [pathname, search, hash]);

  return null;
}